export interface approversEntities {
  roleId: string;
  rolename: string;
  userId: string;
  firstname: string;
  lastname: string;
  number: number;
  overCreditApproverId?: string;
  sequenceId?: string;
}
export const approversEntities_INIT: approversEntities = {
  roleId: "",
  rolename: "",
  userId: "",
  firstname: "",
  lastname: "",
  number: 0,
  overCreditApproverId: "",
  sequenceId: "",
};
export interface sequencesEntities {
  overCreditApproverSequenceId: string;
  groupId: string;
  percent: string;
  roleId: string | undefined;
  rolename: string;
  minApprover: number;
  condition: string;
  approvers: approversEntities[];
}
export const sequencesEntities_INIT: sequencesEntities = {
  overCreditApproverSequenceId: "",
  groupId: "",
  percent: "",
  roleId: undefined,
  rolename: "",
  minApprover: 0,
  condition: "",
  approvers: [approversEntities_INIT],
};
export interface OverCreditApprovedEntities {
  overCreditApproverGroupId: string;
  company: string;
  teamId: string;
  teamName: string;
  zones: string;
  createDate: string;
  createBy: string;
  updateDate: string;
  updateBy: string;
  isDelete: boolean;
  sequences: sequencesEntities[];
}
export const OverCreditApprovedEntities_INIT: OverCreditApprovedEntities = {
  overCreditApproverGroupId: "",
  company: "",
  teamId: "",
  teamName: "",
  zones: "",
  createDate: "",
  createBy: "",
  updateDate: "",
  updateBy: "",
  isDelete: false,
  sequences: [{ ...sequencesEntities_INIT }, { ...sequencesEntities_INIT }],
};
export interface AllOverCreditApprovedEntities {
  data: OverCreditApprovedEntities[];
  updateBy: string;
  updateDate: string;
}
export const AllOverCreditApprovedEntities_INIT: AllOverCreditApprovedEntities = {
  data: [OverCreditApprovedEntities_INIT],
  updateBy: "",
  updateDate: "",
};
export interface CreateOverCreditApprovedEntities {
  company: string;
  teamId: string;
  teamName: string;
  zones: string[];
  sequences: sequencesEntities[];
  createBy: string;
}
export const DEFAULT_sequences = [
  {
    groupId: "",
    percent: 0,
    roleId: "",
    rolename: "",
    minApprover: 0,
    condition: "",
    approvers: [
      {
        sequenceId: "",
        roleId: "",
        rolename: "",
        userId: "",
        firstname: "",
        lastname: "",
        number: 0,
      },
    ],
  },
];
export interface orderOverCreditsEntities {
  orderOverCreditId: string;
  orderId: string;
  company: string;
  customerCompanyId: number;
  taxNo: string;
  primaryCredit: string;
  temporaryCredit: string;
  availableCredit: string;
  accumulatedOverCredit: string;
  requestedOverCredit: string;
  sumOverCredit: number;
  percentOverCredit: number;
  status: string;
  reason: string;
  createBy: string;
  createAt: string;
  updateAt: string;
  updateBy: string;
  lastAction: string;
  isDeleted: boolean;
}
